<app-new-modal-message
  #modalMensagem
  [showFecharBtn]="false"
  [mensagem]="'Erro obtendo os dados da Origem'"
  [titulo]="'Erro!'"></app-new-modal-message>
<app-loader-circles *ngIf="showLoader"></app-loader-circles>
<form [formGroup]="detalhesClienteForm" class="forms">
  <div class="row">
    <div class="row info-container white-box">
      <div class="topFicha">
        <h2>Detalhes do {{ avalistaNumero > 0 ? 'Avalista ' + avalistaNumero : 'Cliente' }}</h2>
        <div class="perfil" *ngIf="perfilCliente">
          <perfil-cliente [perfil]="perfilCliente"></perfil-cliente>
        </div>
      </div>
      <div class="form-group" *ngIf="avalistaNumero > 0">
        <span class="icon documento"></span>
        <div class="inputs">
          <label for="nomeCliente">CPF</label>
          <input
            class="form-control"
            type="text"
            mask-number
            [mask]="'999.999.999-99'"
            formControlName="cpf"
            readonly="true"
            name="cpf"
          >
        </div>
      </div>
      <div class="form-group">
        <span class="icon conjuge"></span>
        <div class="inputs">
          <label for="nomeCliente">Nome</label>
          <input
            (focusout) = "alterarNomeFavorecido()"
            (input) = "omitSpecialCharacter($event)"
            class="form-control"
            type="text"
            placeholder="Nome do cliente"
            maxlength="60"
            required
            appShowErrorMessages
            requiredMessage="O campo Nome é obrigatório"
            formControlName="nomeCliente"
            name="nomeCliente">
        </div>
      </div>
      <div class="form-group">
        <span class="icon conjuge"></span>
        <div class="inputs">
          <label for="nomeCliente">Apelido</label>
          <input
            class="form-control"
            type="text"
            placeholder="Apelido do cliente"
            maxlength="30"
            appShowErrorMessages
            formControlName="apelidoCliente"
            name="apelidoCliente">
        </div>
      </div>
      <div class="form-group">
        <span class="icon email"></span>
        <div class="inputs">
          <label for="emailCliente">Email</label>
          <input
            class="form-control"
            type="email"
            placeholder="email@exemplo.com.br"
            maxlength="60"
            [email]="true"
            appEmailValidator
            appShowErrorMessages
            formControlName="emailCliente"
            inputmode="email"
            name="emailCliente">
        </div>
      </div>
      <div class="form-group">
        <span class="icon celular"></span>
        <div class="inputs">
          <label for="telefonesCliente">Telefones</label>
          <app-telefone-base
            [detalhesClienteForm]="detalhesClienteForm"
            [needsConfirmation]="true"
            [isConfirmado]="this.isConfirmadoTelefone"
            [isRemovable]="false"
            [cliente]="clienteEntity"
            [proposta]="proposta"
            (confirmacaoEmitter)="handleSmsConfirmacao($event)"></app-telefone-base>
          <div class="importante-info">
            <strong>Importante:</strong> precisamos de um número de contato direto com o cliente para agilizar o processo.
          </div>
          <div class="add-dado" (click)="addTelefone()" [ngClass]="{ 'disable-add': telefones.length >= 2 }">
            <p><em class="fa fa-plus"></em> Adicionar telefone</p>
          </div>
          <app-telefone-base
            [adicional]="true"
            [detalhesClienteForm]="detalhesClienteForm"
            [needsConfirmation]="false"
            [isRemovable]="tel == telefones.length -1"
            [index]="tel"
            (telefoneDestroyEventEmitter)="removeTelefone($event)"
            *ngFor="let tel of telefones"></app-telefone-base>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="sexoCliente">Gênero</label>
          <select
            class="form-control"
            required
            appShowErrorMessages
            requiredMessage="O campo Gênero é obrigatório"
            name="sexoCliente"
            formControlName="sexoCliente">
            <option value="" selected hidden>Selecione...</option>
            <option value="F">FEMININO</option>
            <option value="M">MASCULINO</option>
          </select>
        </div>
      </div>
      <div class="form-group" formGroupName="estadoCivil">
        <span class="icon estado-civil"></span>
        <div class="inputs">
          <label for="estadoCivilCliente">Estado Civil</label>
          <select
            class="form-control"
            required
            appShowErrorMessages
            requiredMessage="O campo Estado Civil é obrigatório"
            name="id"
            formControlName="id">
            <option value="" selected hidden>Selecione...</option>
            <option *ngFor="let estadoCivil of estadosCivis" value="{{ estadoCivil.codigo }}">{{ estadoCivil.descricao }}</option>
          </select>
        </div>
      </div>
      <div class="form-group" *ngIf="avalistaNumero < 1">
        <span class="icon dependentes"></span>
        <div class="inputs">
          <label for="dependentes">Número de dependentes</label>
          <input
            class="form-control"
            type="text"
            appOnlyNumber
            inputmode="numeric"
            required
            appShowErrorMessages
            requiredMessage="O campo Número de dependentes é obrigatório"
            formControlName="dependentes"
            min="0"
            max="99"
            maxlength="2"
            name="dependentes">
        </div>
      </div>
      <div class="form-group" *ngIf="avalistaNumero < 1">
        <span class="icon grau-instrucao"></span>
        <div class="inputs">
          <label for="grauInstrucao">Grau de instrução</label>
          <select
            class="form-control"
            required
            appShowErrorMessages
            requiredMessage="O campo Grau de instrução é obrigatório"
            name="grauInstrucao"
            formControlName="grauInstrucao">
            <option value="" selected hidden>Selecione...</option>
            <option *ngFor="let grauInstrucao of grauInstrucaoList" value="{{ grauInstrucao.id }}">{{ grauInstrucao.description }}</option>
          </select>
        </div>
      </div>
    </div>
    <div [formGroup]="conjugeForm" class="row info-container blue-box" *ngIf="hasConjuge">
      <h2>Informações do Cônjuge</h2>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="cpfConjuge">CPF</label>
          <input
            class="form-control"
            type="text"
            placeholder="000.000.000-00"
            mask-number
            [mask]="'999.999.999-99'"
            inputmode="numeric"
            formControlName="cpf"
            name="cpfConjuge"
            (change)="changedCPFConjuge($event?.target?.value)"
          >
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="dataNascimentoConjuge">Data de Nascimento</label>
          <input
            class="form-control"
            type="text"
            mask-number
            [mask]="'99/99/9999'"
            placeholder="00/00/0000"
            inputmode="numeric"
            formControlName="dataNascimento"
            name="dataNascimentoConjuge"
            (change)="changedDataNascimentoConjuge($event.target.value)"
          >
        </div>
      </div>
      <div class="form-group">
        <span class="icon classe-profissional"></span>
        <div class="inputs">
          <label for="classeProfissionalConjuge">Classe Profissional</label>
          <select
            class="form-control"
            appShowErrorMessages
            required
            requiredMessage="O campo Classe Profissional é obrigatório"
            name="classeProfissionalConjuge"
            formControlName="classeProfissionalConjuge"
            (change)="changedProfissoesConjuge($event.target.value)"
          >
            <option value="" selected hidden>Selecione...</option>
            <option *ngFor="let classe of classesProfissionaisConjuge" value="{{ classe.id }}">{{ classe.descricao }}</option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <span class="icon profissao"></span>
        <div class="inputs">
          <label for="profissaoConjuge">Profissão</label>
          <select
            class="form-control"
            required
            appShowErrorMessages
            requiredMessage="O campo Profissão é obrigatório"
            name="profissaoConjuge"
            formControlName="profissaoConjuge">
            <option value="" selected hidden>Selecione...</option>
            <option *ngFor="let profissao of profissoesConjuge" value="{{ profissao.id }}">{{ profissao.descricao }}</option>
          </select>
        </div>
      </div>
      <div class="form-group" *ngIf="isExibeEmpresaConjuge">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="empresaConjuge">Nome da empresa</label>
          <input
            class="form-control"
            type="text"
            maxlength="100"
            placeholder="Empresa"
            formControlName="empresaConjuge"
            name="empresaConjuge"
            required>
        </div>
      </div>
      <div class="form-group" *ngIf="isExibeEmpresaConjuge">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="telefoneConjuge">Telefone da empresa</label>
          <input
            class="form-control"
            type="text"
            minlength="14"
            maxlength="15"
            appShowErrorMessages
            requiredMessage="O campo Telefone da empresa é obrigatório"
            placeholder="(00) 0000-0000"
            formControlName="telefoneEmpresa"
            name="telefoneConjuge"
            required
            appOnlyNumberRestrictive
            inputmode="numeric"
            [value]="conjugeForm.get('telefoneEmpresa').value | telefone">
        </div>
      </div>
    </div>








    <div class="row info-container white-box">
      <div class="form-group">
        <span class="icon profissao"></span>
        <div class="inputs">
          <label for="profissaoCliente">Profissão</label>
          <select2 [data]="profissoes" [cssImport]="false"
                   [value]="detalhesClienteForm?.get('profissaoCliente').value"
                   (valueChanged)="changedProfissoes($event)"></select2>
        </div>
      </div>
      <div class="form-group" *ngIf="isExibeEmpresa">
        <span class="icon predio"></span>
        <div class="inputs">
          <label for="empresaCliente">Nome da empresa</label>
          <input
            class="form-control"
            type="text"
            maxlength="100"
            placeholder="Digite o nome da empresa"
            required
            appShowErrorMessages
            requiredMessage="O campo Nome da Empresa é obrigatório"
            formControlName="empresaCliente"
            name="empresaCliente">
        </div>
      </div>
      <div class="form-group" *ngIf="isExibeEmpresa">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="tempoServico">Tempo de serviço</label>
          <input
            class="form-control"
            type="text"
            mask-number
            [mask]="'99/9999'"
            placeholder="00/0000"
            required
            inputmode="numeric"
            [dateCheck]="detalhesClienteForm.get('tempoServico').value"
            [dateFormat]="tempoServicoFormato"
            dateMessage="Data inválida!"
            appShowErrorMessages
            requiredMessage="O campo Tempo de serviço é obrigatório"
            formControlName="tempoServico"
            name="tempoServico">
        </div>
      </div>
      <div class="form-group" *ngIf="isExibeEmpresa">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="telefoneEmpresaCliente">Telefone da empresa</label>
          <input
            class="form-control"
            type="text"
            placeholder="(00) 0000-0000"
            required
            minlength="14"
            maxlength="15"
            appShowErrorMessages
            requiredMessage="O campo Telefone da empresa é obrigatório"
            formControlName="telefoneEmpresaCliente"
            name="telefoneEmpresaCliente"
            appOnlyNumberRestrictive
            [value]="detalhesClienteForm.get('telefoneEmpresaCliente').value | telefone"
            inputmode="numeric"
            autocomplete="off">
        </div>
      </div>
      <div class="form-group">
        <span class="icon politico"></span>
        <div class="inputs">
          <label for="cargoPoliticoCliente">Politicamente Exposto?</label>
          <small class="subtitle">Exerceu cargo político nos últimos 5 anos ou é parente de algum?</small>
          <div class="input-box" data-toggle="buttons">
            <label class="btn btn-default btn-circle btn-lg" for="isPoliticamenteExposto" [ngClass]="{ 'active': this.clienteEntity.ppe === true }" (click)="setPoliticamenteExposto(true)">
              <input
                type="radio"
                name="isPoliticamenteExposto"
                formControlName="isPoliticamenteExposto"
                value="true">
            </label>
            <span class="radio-label" style="padding-right:20px;">Sim</span>
            <label class="btn btn-default btn-circle btn-lg" for="isPoliticamenteExposto" [ngClass]="{ 'active': this.clienteEntity.ppe === false }" (click)="setPoliticamenteExposto(false)">
              <input
                type="radio"
                name="isPoliticamenteExposto"
                formControlName="isPoliticamenteExposto"
                value="false"
                >
            </label>
            <span class="radio-label" style="padding-right:20px;">Não</span>
          </div>
        </div>
      </div>
      <div class="form-group">
        <span class="icon public-person"></span>
        <div class="inputs">
          <label for="user-expose">FATCA</label>
          <small class="subtitle">Você possui obrigação fiscal com os Estados Unidos da América ou seus territórios?</small>
          <div class="input-box" data-toggle="buttons">
            <label class="btn btn-default btn-circle btn-lg" [ngClass]="{ 'active': this.clienteEntity.fatca === 'S' }" (click)="setFatca('S')">
              <input
                type="radio"
                name="fatca"
                formControlName="fatca"
                value="S">
            </label>
            <span class="radio-label" style="padding-right:20px;">Sim</span>
            <label class="btn btn-default btn-circle btn-lg" [ngClass]="{ 'active': this.clienteEntity.fatca === 'N' || !this.clienteEntity.fatca }" (click)="setFatca('N')">
              <input
                type="radio"
                name="fatca"
                formControlName="fatca"
                value="N"
                checked>
              </label>
            <span class="radio-label" style="padding-right:20px;">Não</span>
          </div>
        </div>
      </div>
      <div class="form-group">
        <span class="icon pessoas"></span>
        <div class="inputs">
          <label for="referenciasCliente">Referências</label>
          <app-referencia-base [detalhesClienteForm]="detalhesClienteForm" [isRemovable]="false"></app-referencia-base>
          <div class="importante-info">
            <strong>Importante:</strong> precisamos de um número de contato direto com a referência para agilizar o processo.
          </div>
          <div class="add-dado" (click)="addReferencia()" [ngClass]="{ 'disable-add': filterReferencias().length >= 1 }">
            <p><em class="fa fa-plus"></em> Adicionar referência</p>
          </div>
          <app-referencia-base
            [detalhesClienteForm]="detalhesClienteForm"
            [index]="ref"
            [isRemovable]="true"
            (referenciaDestroyEventEmitter)="removeReferencia($event)"
            *ngFor="let ref of filterReferencias()">
          </app-referencia-base>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="dadosFavorecidoForm" [formGroup]="dadosFavorecidoForm" class="row info-container blue-box">
    <div class="form-group">
      <span class="icon vazio"></span>
      <div class="inputs">
        <label for="favorecido">Favorecido</label>
        <select
          class="form-control"
          required
          appShowErrorMessages
          requiredMessage="O campo Favorecido é obrigatório"
          name="favorecido"
          formControlName="favorecido">
          <option value="" selected hidden>Selecione...</option>
          <option value="CLIENTE">CLIENTE</option>
          <option value="ORIGEM">ORIGEM</option>
        </select>
      </div>
    </div>
    <div class="form-group">
      <span class="icon vazio"></span>
      <div class="inputs">
        <label for="nomeFavorecido">Nome do Favorecido</label>
        <input
          class="form-control"
          placeholder="Nome do Favorecido"
          formControlName="nomeFavorecido"
          name="nomeFavorecido"
          maxlength="60"
          appShowErrorMessages
          requiredMessage="O campo Nome do Favorecido é obrigatório"
          required>
      </div>
    </div>
    <div class="form-group">
      <span class="icon vazio"></span>
      <div class="inputs">
        <label for="cpfCnpj">CPF/CNPJ</label>
        <input
          class="form-control"
          type="text"
          placeholder="000.000.000-00 ou 00.000.000/0000-00"
          appCpfCnpj
          appShowErrorMessages
          requiredMessage="O campo CPF/CNPJ é obrigatório"
          formControlName="cpfCnpj"
          name="cpfCnpj"
          required
          inputmode="numeric"
          [readOnly]="isCpfCnpjReadOnly"
          [ngClass]="{ 'no-cursor': isCpfCnpjReadOnly }">
      </div>
    </div>
    <div class="form-group">
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="seller-store">Banco</label>
          <select2 [data]="bancos" [cssImport]="false"
                   [value]="detalhesClienteForm?.get('dadosFavorecido').get('banco')?.value"
                   (valueChanged)="changedBancos($event)"></select2>
        </div>
      </div>
    </div>
    <div class="form-group">
      <span class="icon vazio"></span>
      <div class="inputs">
        <label for="agencia">Agência</label>
        <input
          (focusout)="validarAgenciaBancaria()"
          class="form-control"
          type="text"
          placeholder="0000"
          maxlength="4"
          appShowErrorMessages
          requiredMessage="O campo Agência é obrigatório"
          formControlName="agencia"
          name="agencia"
          autocomplete="off"
          appOnlyNumberRestrictive
          inputmode="numeric"
          required>
      </div>
    </div>
    <app-form-group [icon]="'vazio'" [label]="'Conta Corrente'" [labelFor]="'agencia'">
      <div class="row">
        <div class="col-xs-8">
          <input
            class="form-control"
            type="text"
            placeholder="00000000"
            appOnlyNumberRestrictive
            maxlength="18"
            appShowErrorMessages
            requiredMessage="O campo Conta Corrente é obrigatório"
            formControlName="contaCorrente"
            name="contaCorrente"
            required>
        </div>
        <div class="col-xs-4">
          <input
            class="form-control"
            type="text"
            placeholder="0X"
            maxlength="2"
            appShowErrorMessages
            appTextUppercase
            requiredMessage="Digito Verificador é obrigatório"
            formControlName="digitoContaCorrente"
            name="digitoContaCorrente"
            required>
        </div>
      </div>
    </app-form-group>
  </div>
</form>
<app-botao-navegacao
  (previous)="onClickPrevious()"
  (next)="onClickNext()"
  [previousShow]="avalistaNumero > 0"
  [nextShow]="true"
  [nextEnabled]="formValid">
</app-botao-navegacao>
